<div class="w-full h-16 bg-lugano-black flex justify-between items-center">
  <!-- Logo & Title -->
  <div class="h-full px-2 py-1 flex items-center">
    <img src="assets/img/brand/logo-fclugano.png" alt="Logo FC Lugano" class="w-12 h-12 mx-2">
    <div>
      <h1 class="mx-2 text-base font-normal text-lugano-white">3D seatmap</h1>
      <h1 class="mx-2 text-xl font-medium text-lugano-white">FC Lugano</h1>
    </div>
  </div>
  <!-- <div class="h-full px-2 py-1 flex items-center">
    <app-external-button></app-external-button>
  </div> -->
</div>